module.exports = __webpack_public_path__ + "img/icon-cgl@2x.327f9b1a.png";